import * as React from "react";
import { Select } from "@/shared/ui/selects/Select";
import { useAppDispatch, useAppSelector } from "@/app/store/hooks";
import {
    selectDistricts,
    selectPrices,
    selectRoomOptions,
} from "@/entities/site_data/model/selects";
import { selectMapFilterData } from "../model/selects";
import { formatPrice } from "@/shared/lib/utils";
import { ROOM_OPTION_MAP } from "@/shared/config/constants";
import { resetFilterData, updateFilterData } from "../model/slice";
import FilterButton from "@/shared/ui/buttons/FilterButton";

type RoomOptionKey = keyof typeof ROOM_OPTION_MAP;

export function MapFilter() {
    const dispatch = useAppDispatch();

    const prices = useAppSelector(selectPrices)?.map((item) => ({
        id: item,
        name: formatPrice(item),
    })) ?? [];

    const roomOptions = useAppSelector(selectRoomOptions) ?? [];
    const districts = useAppSelector(selectDistricts) ?? [];
    const filterData = useAppSelector(selectMapFilterData);

    const updateFilter = React.useCallback(
        (key: keyof typeof filterData, value: number|null) => {
            dispatch(updateFilterData({ key, value }));
        },
        [dispatch, filterData]
    );

    React.useEffect(() => {
        dispatch(resetFilterData())                     
    }, [])

    return (
        <div className="w-full bg-white rounded-[10px] shadow-bg border border-light-blue flex flex-col items-center md:flex-row md:gap-[12px]">
            <div className="flex flex-row w-full p-[4px] justify-center md:w-fit">
                {roomOptions.map((item) => (

                    <FilterButton
                        key={item}
                        className="px-[24px] first:px-[10px]"
                        active={filterData.apartment === item}
                        onClick={() => updateFilter("apartment", item)}
                    >
                        {ROOM_OPTION_MAP[item as RoomOptionKey]}
                    </FilterButton>
                ))}
            </div>

            <div className="w-[calc(100%-10px)] h-[1px] bg-light-blue md:w-[1px] md:h-[36px]" />

            <div className="flex flex-row w-full gap-[12px] py-[4px]">
                <Select
                    placeholder="Район"
                    selected={filterData.districtId}
                    className="w-1/2"
                    list={districts}
                    handleSelect={(id: number|null) => updateFilter("districtId", id)}
                />
                <div className="w-[1px] h-[36px] bg-light-blue" />
                <Select
                    placeholder="Стоимость"
                    selected={filterData.price}
                    className="w-1/2"
                    list={prices}
                    handleSelect={(id: number|null) => updateFilter("price", id)}
                />
            </div>
        </div>
    );
}
